import { LoadingSpinner } from '@components';
import { SimcardService } from '@services';
import { RootState, fetchSimData, setMetricGroups } from '@stores';
import { transformToGrouped } from '@utils';
import { getMockMetricDetails } from '@utils/metrics/getMockMetricDetail';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MonthlyBillingCard from './MonthlyBillingCard';

type Props = {
  phoneNumbers?: string[];
};

export const SimUsageLineGraph = ({ phoneNumbers }: Props) => {
  const { loading, simData, simDataTotal } = useSelector(
    (state: RootState) => state.simData
  );
  const companyId = useSelector(
    (state: RootState) => state.companies.selectedCompany?.id
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const date = new Date();
  const currentYear = date.getFullYear();
  const years =
    process.env.NODE_ENV === 'development'
      ? [2023, 2024, 2025]
      : [currentYear - 1, currentYear];

  useEffect(() => {
    if (companyId) {
      dispatch(
        fetchSimData({
          props: {
            phoneNumbers: phoneNumbers,
            years: years,
            limit: 24,
          },
          companyId: companyId,
        })
      );
    }
  }, [phoneNumbers, companyId]);

  const handleClick = async (e) => {
    const sim = new SimcardService();

    //todo: Create a custom hook for mocking data
    if (companyId === 1) {
      const values = transformToGrouped(getMockMetricDetails(e.month).results);
      dispatch(setMetricGroups(values));
      return;
    }

    const data = await sim.getBruto(
      {
        months: [e.month],
        metricGroups: [
          'calls',
          'data',
          'mpay',
          'others',
          'sms',
          'subscriptions',
        ],
        years: [e.year],
        // phoneNumbers: [phoneNumbers],
      },
      companyId
    );

    const result = transformToGrouped(data.results);
    dispatch(setMetricGroups(result));
  };

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : simDataTotal > 0 ? (
        <MonthlyBillingCard
          label={t(`Periode: 12 Maanden`)}
          price={simDataTotal}
          data={simData}
          onClick={handleClick}
        />
      ) : (
        <p>Geen data</p>
      )}
    </>
  );
};

export default SimUsageLineGraph;
